import { ChildrenProps, IconButtonProps, IconButton } from '@dfl/mui-react-common';
import { Box, CircularProgress } from '@mui/material';
import { memo } from 'react';

type LoadingIconButtonProps = { loading: boolean; tooltip?: string } & Omit<IconButtonProps, 'tooltip'> & ChildrenProps;

const LoadingIconButton = ({ loading, tooltip, children, ...props }: LoadingIconButtonProps) => {
  return (
    <IconButton {...props} tooltip={tooltip || ''}>
      {loading ? (
        <Box sx={{ display: 'flex' }}>
          <CircularProgress size={16} />
        </Box>
      ) : (
        children
      )}
    </IconButton>
  );
};

export default memo(LoadingIconButton);
